/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import appConfig from '@bingads-webui-component-legacy/config/index';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import * as columnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences';
import * as legacyColumnChooserPreferences from '@bingads-webui-component-legacy/bingads-grid/service/legacy-column-chooser-preferences';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import appState from '@bingads-webui-component-legacy/state/index';
import * as preferenceService from '@bingads-webui-component-legacy/preference/service/index';
import sessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import * as preferenceStoreFactory from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import cacheService from '@bingads-webui-static-legacy/cache-service';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import { ProductOffer } from '@bingads-webui-campaign/campaign-ui-schemas';
import pageContext from '@bingads-webui-static-legacy/page-context';


const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/product-feed');
const schemaI18nCampaign = window.globalLegacyI18n.get('$/schema-i18n!campaign');
export const brandGridLegacyDepsList = {
  '@bingads-webui/i18n-amd-loader!campaignui/feature/product-feed': i18n,
  'component/edm-campaign/index': edm,
  'component/config/index': appConfig,
  'module/service/instrumentation/index': logger,
  'component/bingads-grid/service/column-chooser-preferences': columnChooserPreference,
  'component/bingads-grid/service/legacy-column-chooser-preferences': legacyColumnChooserPreferences,
  'component/js-data-campaign/index': jsDataCampaign,
  'component/state/index': appState,
  'component/preference/service/index': preferenceService,
  '$/schema!campaign/ProductOffer': ProductOffer,
  'component/js-data-storage/session-storage': sessionStore,
  'component/bingads-grid/service/filter-preferences': preferenceStoreFactory,
  'Services/CacheService': cacheService,
  SummaryDataContextManager: dataContextManager,
  '$/schema-i18n!campaign': schemaI18nCampaign,
  PageContext: pageContext,
};

export const extraDepList = [
  '$/i18n!legacy/global',
  'module/app/component/azureUrlRewrite',
];

export const inlineChartDepList = [
  '@bingads-webui/i18n-amd-loader!@bingads-webui-campaign-react/inline-chart',
  'Constants',
  '$/i18n!global',
  'component/bingads-grid/service/grid-preferences',
];

export const pageDepList = [
  'component/bingads-grid/shared/timeRangeChecker',
  'component/bingads-grid/service/fetch-pagination',
];
